import {
  ClipboardTick,
  Messages1,
  Messages2,
  Setting2,
  DocumentText,
  Profile2User,
  ProfileCircle,
  FlashCircle
} from 'iconsax-react'

import NavItem, { DashboardNavItem, PeerChatItem } from './NavItem'

import { Routes } from '../../../Routes'
import { PERMS } from '../../../hooks/useAccess'

const TaskIcon = () => (
  <ClipboardTick size='24' variant='Bulk' color='#5E5E5E' />
)
const PeerChatsIcon = () => (
  <Messages1 size='24' variant='Bulk' color='#5E5E5E' />
)

const ConversationsIcon = () => (
  <Messages2 size='24' variant='Bulk' color='#5E5E5E' />
)

const SettingsIcon = () => <Setting2 size='24' variant='Bulk' color='#5E5E5E' />

const KnowledgeIcon = () => (
  <DocumentText size='24' variant='Bulk' color='#5E5E5E' />
)
const TeamIcon = () => <Profile2User size='24' variant='Bulk' color='#5E5E5E' />

const ContactsIcon = () => (
  <ProfileCircle size='24' variant='Bulk' color='#5E5E5E' />
)
const DashboardIcon = () => (
  <FlashCircle size='24' variant='Bulk' color='#5E5E5E' />
)

export const getTopOptions = hasPermission => {
  const dashLink = {
    link: Routes.DASHBOARD,
    aliases: [],
    name: 'Dashboard',
    Content: DashboardIcon,
    testId: 'dashboard-link'
  }

  const canViewClients = hasPermission(PERMS.ConversationsBasic)
  const clientLink = canViewClients
    ? {
        link: Routes.CLIENT_CHATS,
        aliases: [Routes.TIMELINE],
        name: 'Client Conversations',
        testId: 'conversations-link',
        Content: ConversationsIcon,
        Item: DashboardNavItem,
        onMove: () => {
          sessionStorage.removeItem('viewing')
          sessionStorage.removeItem('blockView')
          sessionStorage.removeItem('empty')
        }
      }
    : null

  const canViewPeers = hasPermission(PERMS.PeerFull)
  const peerLink = canViewPeers
    ? {
        link: Routes.PEER_CHAT,
        aliases: [],
        name: 'Team Chats',
        testId: 'peerchats-link',
        Content: PeerChatsIcon,
        Item: PeerChatItem
      }
    : null

  const canViewTasks = hasPermission([PERMS.TasksOwn, PERMS.TasksAudit])
  const taskLink = canViewTasks
    ? {
        link: Routes.TASKS,
        aliases: [],
        name: 'Tasks',
        testId: 'tasks-link',
        Content: TaskIcon
      }
    : null

  const canViewCustomers = hasPermission([
    PERMS.ContactsOwn,
    PERMS.ContactsAudit
  ])
  const customerLink = canViewCustomers
    ? {
        link: Routes.CUSTOMERS,
        aliases: [],
        name: 'Contacts',
        testId: 'contacts-link',
        Content: ContactsIcon
      }
    : null

  return [dashLink, clientLink, peerLink, taskLink, customerLink].filter(
    Boolean
  )
}

export const getBottomOptions = hasPermission => {
  const canViewUsers = hasPermission([PERMS.UsersBasic, PERMS.UsersSelf])
  const usersLink = canViewUsers
    ? {
        link: Routes.USERS,
        aliases: [],
        name: 'Team',
        Content: TeamIcon,
        testId: 'team-link'
      }
    : null

  const knowledgeLink = {
    link: Routes.DOCUMENTS,
    aliases: [],
    name: 'Knowledge Base',
    testId: 'documents-link',
    Content: KnowledgeIcon
  }
  const settingsLink = {
    link: Routes.SETTINGS,
    aliases: [],
    name: 'Settings',
    testId: 'settings-link',
    Content: SettingsIcon
  }

  // const helpLink = {
  //   name: 'Help',
  //   aliases: [],
  //   Item: HelpItem,
  //   Content: HelpIcon,
  //   onClick: () => {
  //     const frame = document.getElementById('document360-widget-iframe')

  //     if (frame) {
  //       frame.contentDocument.getElementById('doc360-button').click()
  //     }
  //   }
  // }

  return [usersLink, knowledgeLink, settingsLink].filter(Boolean)
}

export const getAllOptions = hasPermission => {
  const topOptions = getTopOptions(hasPermission)
  const bottomOptions = getBottomOptions(hasPermission)
  return [...topOptions, ...bottomOptions]
}

export const createNavItem = classes => (item, i) => {
  const props = {
    to: item.link,
    name: item.name,
    onMove: item.onMove,
    aliases: item.aliases,
    dataTestId: item.testId
  }

  const { Content, Item = NavItem } = item

  return (
    <Item key={i} {...props}>
      <Content className={classes.icon} />
    </Item>
  )
}
